
import React, { createContext, useState, useContext, ReactNode } from 'react';
import { translations } from '../constants';

type Language = 'ar' | 'tr';
type Direction = 'rtl' | 'ltr';

interface LanguageContextType {
  lang: Language;
  dir: Direction;
  setLang: (lang: Language) => void;
  t: (key: keyof typeof translations.ar) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<Language>('tr');
  const [dir, setDir] = useState<Direction>('ltr');

  const setLang = (newLang: Language) => {
    setLangState(newLang);
    setDir(newLang === 'ar' ? 'rtl' : 'ltr');
  };

  const t = (key: keyof typeof translations.ar): string => {
    return translations[lang][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, dir, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
